import {z} from 'zod';

export const DatiqCellSelectChangeSchema = z.object({
    checked: z.boolean(),
    data: z.any().optional()
})

export interface IDatiqCellSelectChange<D = any> extends z.infer<typeof DatiqCellSelectChangeSchema>{
    data?: D;
}

export const DatiqCellSelectSchema = z.object({
    selected: z.boolean(),
    indeterminate: z.boolean(),
    disabled: z.boolean(),
    data: z.any().optional()
})

export interface IDatiqCellSelect<D = any> extends z.infer<typeof DatiqCellSelectSchema>{
    data?: D;
}
